import { CATEGORY_HIERARCHY } from './categories';

export const UNITS = {
    // Basic units
    WEIGHT: {
      kg: "Kilogramos",
      gr: "Gramos",
      ton: "Toneladas",
      lb: "Libras"
    },
    VOLUME: {
      lt: "Litros",
      ml: "Mililitros",
      m3: "Metros Cúbicos",
      gal: "Galones"
    },
    LENGTH: {
      mt: "Metros",
      cm: "Centímetros",
      mm: "Milímetros",
      pulg: "Pulgadas"
    },
    AREA: {
      m2: "Metros Cuadrados",
      ha: "Hectáreas",
      pie2: "Pies Cuadrados"
    },
    QUANTITY: {
      unidad: "Unidad",
      par: "Par",
      docena: "Docena",
      caja: "Caja",
      pack: "Pack",
      "pack x 6": "Pack x 6",
      "pack x 12": "Pack x 12",
      "pack x 24": "Pack x 24",
      "caja x 6": "Caja x 6",
      "caja x 12": "Caja x 12",
      "caja x 24": "Caja x 24",
      rollo: "Rollo",
      pallet: "Pallet",
      bulto: "Bulto",
      bolsa: "Bolsa",
      tambor: "Tambor",
      bidon: "Bidón",
      display: "Display",
      millar: "Millar",
      resma: "Resma",
      bobina: "Bobina",
      atado: "Atado",
      fardo: "Fardo",
      set: "Set",
      kit: "Kit"
    },
    POWER: {
      hp: "HP",
      kw: "Kilowatts"
    }
  };
  
  // Category-specific unit mappings
  export const CATEGORY_UNITS = {
    // Alimentos y Bebidas
    "Carnes Rojas": ["kg", "gr", "pack", "caja"],
    "Carnes de Cerdo": ["kg", "gr", "pack", "caja"],
    "Pescados y Mariscos": ["kg", "gr", "pack", "caja"],
    "Aves": ["kg", "gr", "unidad", "caja"],
    "Lácteos y Huevos": ["lt", "kg", "unidad", "docena", "pack x 6", "pack x 12"],
    "Frutas y Verduras": ["kg", "gr", "caja", "pack"],
    "Panadería": ["kg", "gr", "unidad", "docena", "pack"],
    "Bebidas Alcohólicas": ["lt", "ml", "unidad", "caja", "pack", "pack x 6", "pack x 12", "pack x 24"],
    "Bebidas Sin Alcohol": ["lt", "ml", "unidad", "pack", "pack x 6", "pack x 12", "pack x 24", "bidon"],
    "Infusiones": ["kg", "gr", "unidad", "pack", "caja x 20", "caja x 25", "caja x 50"],
    "Alimentos Secos": ["kg", "gr", "unidad", "pack", "bolsa", "caja"],
    "Congelados": ["kg", "gr", "unidad", "caja", "pack"],
    "Conservas": ["unidad", "kg", "caja", "pack x 6", "pack x 12", "pack x 24"],
  
    // Textiles y Telas
    "Telas": ["mt", "m2", "rollo", "kg", "fardo"],
    "Mercería": ["unidad", "docena", "pack", "caja", "rollo", "mt"],
    "Telas Especiales": ["mt", "m2", "rollo", "kg", "fardo"],
    "Cueros y Sintéticos": ["pie2", "m2", "rollo", "kg", "fardo"],
    "Materiales de Costura": ["unidad", "pack", "caja", "rollo", "mt"],
  
    // Industria y Manufactura
    "Maquinaria Industrial": ["unidad", "set", "kit"],
    "Equipamiento de Seguridad": ["unidad", "par", "pack", "kit", "caja", "set"],
    "Insumos Industriales": ["lt", "kg", "tambor", "bidon", "contenedor", "caja", "pack"],
    "Empaque y Embalaje": ["unidad", "rollo", "pack", "pallet", "caja", "fardo"],
    "Herramientas Industriales": ["unidad", "kit", "set", "caja", "pack"],
  
    // Químicos y Laboratorio
    "Químicos Industriales": ["lt", "kg", "gr", "tambor", "bidon", "contenedor", "pack", "caja"],
    "Equipamiento de Laboratorio": ["unidad", "kit", "set", "pack", "caja"],
    "Productos de Limpieza": ["lt", "kg", "unidad", "bidon", "caja", "pack"],
  
    // Agricultura y Ganadería
    "Insumos Agrícolas": ["kg", "lt", "bolsa", "bidon", "tambor", "contenedor"],
    "Fertilizantes": ["kg", "lt", "bolsa", "bidon", "tambor", "contenedor", "ton"],
    "Semillas": ["kg", "bolsa", "pack", "unidad"],
    "Agroquímicos": ["lt", "kg", "bidon", "tambor", "contenedor"],
    "Maquinaria Agrícola": ["unidad", "kit", "set"],
    "Ganadería": ["kg", "unidad", "bolsa", "ton", "pack"],
  
    // Embalajes y Logística
    "Cajas y Contenedores": ["unidad", "pack", "pallet", "fardo", "millar"],
    "Material de Embalaje": ["rollo", "unidad", "pack", "caja", "fardo"],
    "Equipamiento Logístico": ["unidad", "pack", "set", "kit"],
  
    // Construcción
    "Materiales de Construcción": ["unidad", "kg", "m3", "bolsa", "pallet", "ton"],
    "Cemento y Cal": ["bolsa", "kg", "pallet", "ton"],
    "Ladrillos y Bloques": ["unidad", "pallet", "m2", "millar"],
    "Arena y Piedras": ["m3", "kg", "ton", "camión", "bolsa"],
    "Hormigón": ["m3", "kg", "ton"],
    "Hierros y Mallas": ["unidad", "mt", "kg", "ton", "pallet", "atado"],
    "Membranas y Aislantes": ["rollo", "m2", "unidad"],
    "Maderas": ["unidad", "pie2", "m2", "pulgadas", "pallet"],
    "Chapas": ["unidad", "mt", "m2", "pallet"],
  
    // Químicos
    "Ácidos": ["lt", "kg", "bidon", "tambor", "contenedor"],
    "Solventes Químicos": ["lt", "tambor", "bidon", "contenedor"],
  
    // Textiles
    "Telas": ["mt", "m2", "rollo", "kg", "fardo"],
    "Mercería": ["unidad", "docena", "pack", "caja", "rollo", "mt"],
    "Cueros y Sintéticos": ["pie2", "m2", "rollo", "kg", "fardo"],
  
    // Industria
    "Maquinaria Industrial": ["unidad", "set", "kit"],
    "Empaque y Embalaje": ["unidad", "rollo", "pack", "pallet", "caja", "fardo"],
  
    // Agricultura
    "Insumos Agrícolas": ["kg", "lt", "bolsa", "bidon", "tambor", "contenedor"],
    "Fertilizantes": ["kg", "lt", "bolsa", "bidon", "tambor", "contenedor", "ton"],
    "Semillas": ["kg", "bolsa", "pack", "unidad"],
    "Agroquímicos": ["lt", "kg", "bidon", "tambor", "contenedor"],
  
    // Embalajes
    "Cajas y Contenedores": ["unidad", "pack", "pallet", "fardo", "millar"],
    "Material de Embalaje": ["rollo", "unidad", "pack", "caja", "fardo"],
    "Film Stretch": ["rollo", "unidad", "pack", "caja"],
    "Cintas de Embalaje": ["rollo", "unidad", "pack", "caja"],
  
    // Papelería
    "Papel": ["unidad", "resma", "caja", "pack", "rollo", "bobina"],
    "Artículos de Escritura": ["unidad", "docena", "caja", "pack", "set"],
    "Material de Oficina": ["unidad", "pack", "caja", "set", "kit"],
    "Cuadernos y Blocks": ["unidad", "docena", "pack", "caja"],
    "Insumos de Impresión": ["unidad", "pack", "caja", "kit"],
  
    // Automotor
    "Repuestos Autos": ["unidad", "kit", "set", "pack", "caja"],
    "Repuestos Motos": ["unidad", "kit", "set", "pack", "caja"],
    "Lubricantes": ["lt", "bidon", "tambor", "caja", "pack"],
    "Neumáticos": ["unidad", "kit", "set", "pack"],
    "Accesorios Vehiculares": ["unidad", "kit", "set", "pack", "caja"],
    "Herramientas Automotor": ["unidad", "kit", "set", "caja"],
  
    // Electrónica
    "Televisores": ["unidad", "pack", "caja"],
    "Celulares y Tablets": ["unidad", "pack", "caja"],
    "Computadoras": ["unidad", "pack", "kit", "set"],
    "Electrodomésticos": ["unidad", "pack", "kit"],
    "Audio y Video": ["unidad", "pack", "kit", "set"],
    "Fotografía": ["unidad", "kit", "set", "pack"],
  
    // Hogar
    "Muebles": ["unidad", "kit", "set", "pack"],
    "Decoración": ["unidad", "pack", "set", "kit", "caja"],
    "Iluminación": ["unidad", "pack", "kit", "caja"],
    "Textiles del Hogar": ["unidad", "pack", "docena", "set", "kit"],
    "Jardín y Exterior": ["unidad", "pack", "kit", "set", "m2"],
    "Baño y Cocina": ["unidad", "pack", "kit", "set", "caja"],
  
    // Indumentaria
    "Ropa Hombre": ["unidad", "pack", "docena", "caja"],
    "Ropa Mujer": ["unidad", "pack", "docena", "caja"],
    "Ropa Niños": ["unidad", "pack", "docena", "caja"],
    "Calzado": ["par", "docena", "caja", "pack"],
    "Accesorios": ["unidad", "pack", "docena", "caja", "set"],
  
    // Nuevas subcategorías de Alimentos
    "Aceites y Vinagres": ["lt", "ml", "unidad", "bidon", "caja", "pack x 6", "pack x 12"],
    "Aceite de Oliva": ["lt", "ml", "unidad", "bidon", "caja x 6", "caja x 12"],
    "Aceite de Girasol": ["lt", "ml", "unidad", "bidon", "caja x 6", "caja x 12"],
    "Aceite de Maíz": ["lt", "ml", "unidad", "bidon", "caja x 6", "caja x 12"],
    "Aceite Vegetal": ["lt", "ml", "unidad", "bidon", "caja x 6", "caja x 12"],
    "Vinagre de Vino": ["lt", "ml", "unidad", "bidon", "caja x 6", "caja x 12"],
    "Vinagre Balsámico": ["lt", "ml", "unidad", "caja x 6", "caja x 12"],
    
    "Condimentos y Especias": ["kg", "gr", "unidad", "pack", "caja"],
    "Sal": ["kg", "gr", "unidad", "pack", "bolsa"],
    "Pimienta": ["kg", "gr", "unidad", "pack", "bolsa"],
    "Condimentos para Carnes": ["kg", "gr", "unidad", "pack", "caja"],
    "Especias Enteras": ["kg", "gr", "unidad", "pack", "bolsa"],
    "Especias Molidas": ["kg", "gr", "unidad", "pack", "bolsa"],
    "Hierbas Aromáticas": ["kg", "gr", "unidad", "pack", "bolsa"],
    
    "Salsas y Aderezos": ["kg", "gr", "lt", "ml", "unidad", "pack", "caja"],
    "Mayonesa": ["kg", "gr", "unidad", "pack", "caja x 6", "caja x 12"],
    "Mostaza": ["kg", "gr", "unidad", "pack", "caja x 6", "caja x 12"],
    "Ketchup": ["kg", "gr", "unidad", "pack", "caja x 6", "caja x 12"],
    "Salsa Golf": ["kg", "gr", "unidad", "pack", "caja x 6", "caja x 12"],
    "Salsa de Soja": ["lt", "ml", "unidad", "pack", "caja x 6", "caja x 12"],
    
    "Snacks y Golosinas": ["kg", "gr", "unidad", "pack", "caja", "display"],
    "Papas Fritas": ["kg", "gr", "unidad", "pack", "caja", "display"],
    "Maní": ["kg", "gr", "unidad", "pack", "caja", "bolsa"],
    "Palitos Salados": ["kg", "gr", "unidad", "pack", "caja", "display"],
    "Chocolates": ["kg", "gr", "unidad", "pack", "caja", "display"],
    "Caramelos": ["kg", "gr", "unidad", "pack", "caja", "display"],
    "Galletitas": ["kg", "gr", "unidad", "pack", "caja", "display"],
    
    "Desayuno y Merienda": ["kg", "gr", "unidad", "pack", "caja"],
    "Cereales": ["kg", "gr", "unidad", "pack", "caja"],
    "Granola": ["kg", "gr", "unidad", "pack", "caja"],
    "Mermeladas": ["kg", "gr", "unidad", "pack", "caja x 6", "caja x 12"],
    "Dulce de Leche": ["kg", "gr", "unidad", "pack", "caja x 6", "caja x 12"],
    "Miel": ["kg", "gr", "unidad", "pack", "caja x 6", "caja x 12"],
    "Mantequilla de Maní": ["kg", "gr", "unidad", "pack", "caja x 6", "caja x 12"],
    
    "Enlatados y Conservas": ["unidad", "pack", "caja x 6", "caja x 12", "caja x 24", "pallet"],
    "Atún": ["unidad", "pack", "caja x 6", "caja x 12", "caja x 24", "pallet"],
    "Sardinas": ["unidad", "pack", "caja x 6", "caja x 12", "caja x 24"],
    "Caballa": ["unidad", "pack", "caja x 6", "caja x 12", "caja x 24"],
    "Arvejas": ["unidad", "pack", "caja x 6", "caja x 12", "caja x 24"],
    "Choclo": ["unidad", "pack", "caja x 6", "caja x 12", "caja x 24"],
    "Palmitos": ["unidad", "pack", "caja x 6", "caja x 12", "caja x 24"],
  };
  
  // Helper function to get available units for a category
  export const getUnitsForCategory = (category) => {

    // If no category is selected, return all units
    if (!category) {
      return Object.values(UNITS).reduce((acc, unitType) => {
        return [...acc, ...Object.entries(unitType).map(([value, label]) => ({
          value,
          label
        }))];
      }, []);
    }

    // First check if it's a direct match in CATEGORY_UNITS
    if (category && CATEGORY_UNITS.hasOwnProperty(category)) {
      return CATEGORY_UNITS[category].map(unitKey => {
        for (const unitType of Object.values(UNITS)) {
          if (unitType[unitKey]) {
            return { value: unitKey, label: unitType[unitKey] };
          }
        }
      }).filter(Boolean);
    }

    // If not found, look through the hierarchy
    for (const [mainCat, data] of Object.entries(CATEGORY_HIERARCHY)) {
      for (const [subCat, items] of Object.entries(data.subcategories)) {
        // Check if the category is in the items array
        if (items.includes(category)) {
          // Use subcategory units if available
          const unitsToUse = CATEGORY_UNITS[subCat] || CATEGORY_UNITS[mainCat] || Object.keys(UNITS.QUANTITY);
          
          return unitsToUse.map(unitKey => {
            for (const unitType of Object.values(UNITS)) {
              if (unitType[unitKey]) {
                return { value: unitKey, label: unitType[unitKey] };
              }
            }
          }).filter(Boolean);
        }
      }
    }

    // Default to quantity units if no specific mapping found
    return Object.entries(UNITS.QUANTITY).map(([value, label]) => ({
      value,
      label
    }));
  };
  
  // Default units for shipping calculations
  export const SHIPPING_UNITS = [
    { value: 'kg', label: 'Kilogramos' },
    { value: 'ton', label: 'Toneladas' },
    { value: 'm3', label: 'Metros Cúbicos' },
    { value: 'unit', label: 'Unidad' }
  ]; 